"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAutomaticFileConversionStatusEvents = void 0;
const rxjs_1 = require("rxjs");
const FileConversionActions = require("../../../actions/files/automaticFileConversion");
const eventTypes = require("../eventTypes");
const utils_1 = require("../utils");
const operators_1 = require("rxjs/operators");
const handleStatus = (action) => (0, utils_1.validate)(action.payload, eventTypes.iRevisionConversionStatusEvent, () => {
    const event = action.payload;
    return (0, rxjs_1.of)(FileConversionActions.updateRevisionConversionStatus({
        revisionUuid: event.message.revisionUuid,
        preview: JSON.parse(event.message.preview)
    }));
});
const handleStatusError = (action) => (0, utils_1.validate)(action.payload, eventTypes.iRevisionConversionErrorEvent, () => {
    const event = action.payload;
    return (0, rxjs_1.of)(FileConversionActions.setRevisionConversionError({
        revisionUuid: event.message.revisionUuid,
        error: event.message.error
    }));
});
const handleAutomaticFileConversionStatusEvents = (action$) => {
    const handleError = (type) => (error) => (0, rxjs_1.of)({ type, payload: error });
    if (action$.payload.event === eventTypes.REVISION_CONVERSION_STATUS) {
        return handleStatus(action$).pipe((0, operators_1.catchError)(handleError('FILE_CONVERSION_ERROR')));
    }
    return handleStatusError(action$).pipe((0, operators_1.catchError)(handleError('FILE_CONVERSION_ERROR')));
};
exports.handleAutomaticFileConversionStatusEvents = handleAutomaticFileConversionStatusEvents;
//# sourceMappingURL=automaticFileConversion.js.map